import gql from 'graphql-tag';

export const GET_ZONE_CONFIGURATIONS_BY_FACILITY = gql`
  query GetZoneConfigurationsByFacility($userFacility: String!) {
    GetZoneConfigurationsByFacility(UserFacility: $userFacility) {
      Id
      Name
      Stations {
        Id
        InspectionTasks {
          Id
          Name
          ResultSetName
          AllowedResults {
            Id
            ResultValue
          }
        }
        Name
      }
    }
  }
`;

export const SYNC_ZONES_WITH_STATIONS = gql`
  mutation syncZonesWithStations($payload: String!) {
    SyncZonesWithStations(Payload: $payload) {
      Success
      Message
      UpdatedData
    }
  }
`;
